import type { StrapiBuilderLayoutData } from '@autobid/strapi-integration/typescript/strapi/Page'

export interface HeaderProps {
  data: StrapiBuilderLayoutData
  callbackUrl: string
}

export function usePageHeader() {
  const openReasonOnAuthorize = (bidBlockedBtn: HTMLButtonElement) => {
    if (bidBlockedBtn) {
      bidBlockedBtn.click()

      setTimeout(() => {
        if (bidBlockedBtn.dataset.open === 'true') {
          bidBlockedBtn.click()
        }
      }, 10000)
    }
  }

  return { openReasonOnAuthorize }
}
